import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { rowExpandAnimation } from "src/app/animations/row-expand-animation";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { DocType } from "src/app/models/Enums";
import { Event } from "src/app/models/Event";
import { ToolDetails } from "src/app/models/ToolDetails";
import { CompanyService } from "src/app/services/company.service";

import { EventsByOrder } from "../../models/EventsByOrder";

@Component({
  selector: "app-tool-history",
  templateUrl: "./tool-history.component.html",
  styleUrls: ["./tool-history.component.scss"],
  animations: [rowExpandAnimation],
  standalone: false,
})
export class ToolHistoryComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  faDownload = faDownload;
  isExpanded: boolean;
  dataSource = new MatTableDataSource<EventsByOrder>([]);
  toolDetails: ToolDetails; // this prop is set by parent component

  constructor(private companyService: CompanyService) {}

  ngOnInit(): void {
    this.setToolHistory();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  setToolHistory() {
    this.dataSource.data = this.toolDetails.eventsByRaNumber;
    this.dataSource.data.forEach((x) => {
      x.flowType = this.getFlowType(x.raNumber);
      //x.startDate = minBy(x.events, (e) => e.date).date;
      x.expanded = false;

      if (x.hasAnyDummyEquipmentEvent) {
        this.addLinkToFSJob(x);
      }
      this.handleWorkshop(x);
    });
  }

  public onEventGroupClick(ra: EventsByOrder) {
    ra.expanded = !ra.expanded;
  }

  private addLinkToFSJob(eventGroup: EventsByOrder): EventsByOrder {
    eventGroup.flowType = this.getFlowType(eventGroup.raNumber);
    eventGroup.linkToFieldServiceJob = `${RouteNameConstants.FIELD_SERVICE}/Planned/${this.companyService.selectedCompany.name}/${eventGroup.raNumber}`;

    return eventGroup;
  }

  private handleWorkshop(eventGroup: EventsByOrder): void {
    eventGroup.events.forEach((e) => {
      e.docs = [];
      e.documents.forEach((d) => {
        (d.documentType = DocType.EventDocument), e.docs.push(d);
      });
      e.certificates.forEach((c) => {
        (c.documentType = DocType.Certificate), e.docs.push(c);
      });
    });
  }

  private getFlowType(raNumber: string) {
    if (
      raNumber?.startsWith("FSESI") ||
      (raNumber?.startsWith("FS") && !raNumber?.startsWith("FSE"))
    )
      return "toolhistory.fieldserviceflow";

    return "toolhistory.workshopflow";
  }

  public getEventsDataSource(events: Event[], matSort: MatSort): MatTableDataSource<Event> {
    const dataSource = new MatTableDataSource<Event>(events);
    dataSource.sort = matSort;
    return dataSource;
  }

  public toggleExpandRow(ra: EventsByOrder): void {
    ra.expanded = !ra.expanded;
  }

  public isExpansionDetailRow(index: number, ra: EventsByOrder): boolean {
    return ra.events.length > 0;
  }
}
